var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Tab as RbTab } from "react-bootstrap";
import Headers from "./Headers";
import StyledHr from "./styled/Hr";
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.render = function () {
        var _a = this.props, tabs = _a.tabs, id = _a.id, fullWidth = _a.fullWidth, onSelect = _a.onSelect, activeKey = _a.activeKey, mountOnEnter = _a.mountOnEnter, unmountOnExit = _a.unmountOnExit, activeHeaderColor = _a.activeHeaderColor, className = _a.className;
        var defaultActiveKey = activeKey || tabs[0].key;
        return (React.createElement(RbTab.Container, { id: id, defaultActiveKey: defaultActiveKey, onSelect: onSelect, className: className },
            React.createElement("div", null,
                React.createElement(Headers, { tabs: tabs, fullWidth: fullWidth, activeColor: activeHeaderColor }),
                React.createElement(StyledHr, null),
                React.createElement(RbTab.Content, { mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }, tabs.map(function (_a) {
                    var key = _a.key, component = _a.component;
                    return (React.createElement(RbTab.Pane, { key: key, eventKey: key }, component));
                })))));
    };
    Tabs.defaultProps = {
        activeKey: null,
        onSelect: function () { },
        fullWidth: false,
        mountOnEnter: false,
        unmountOnExit: false,
        activeHeaderColor: undefined,
        className: null
    };
    return Tabs;
}(PureComponent));
export default Tabs;
